/**
 * Zero-dependency HTML escape utilities for non-React contexts.
 *
 * Use this for:
 * - Electron main process HTML strings (OAuth pages, error pages)
 * - DOM manipulation via innerHTML where React is unavailable
 * - Any string interpolation into HTML templates
 *
 * In React components, JSX auto-escapes — use these only for raw DOM/innerHTML.
 */

const ESCAPE_MAP: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
};

const ESCAPE_RE = /[&<>"']/g;

/**
 * Escape HTML special characters to prevent XSS in innerHTML contexts.
 */
export function escapeHtml(str: string): string {
  if (!str) return '';
  return str.replace(ESCAPE_RE, (ch) => ESCAPE_MAP[ch] || ch);
}
